import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
import { OrderDeliveryMethodCdekDto } from './OrderDeliveryMethodCdekDto'
import { OrderDeliveryMethodCdekCourierDto } from './OrderDeliveryMethodCdekCourierDto'
import { OrderDeliveryMethodPickupDto } from './OrderDeliveryMethodPickupDto'
import { OrderDeliveryMethodManualDto } from './OrderDeliveryMethodManualDto'
import { OrderDeliveryMethodPochtaDto } from './OrderDeliveryMethodPochtaDto'
import { OrderDeliveryMethodPochtaCourierDto } from './OrderDeliveryMethodPochtaCourierDto'
import { DeliveryMethodKind } from './Enums'
/**
* Class OrderDeliveryDto
*  Информация о доставке<br>
*/
export class OrderDeliveryDto extends ActiveModel {

  /**
  * kind
  * словарь значений публикуется под именем `Domain.Entities.Channels.DeliveryMethodKind`  *   * Вид способа доставки.  *   * - `Cdek` СДЭК  *   * Интеграция СДЭК (не более одной записи на канал).  * - `CdekCourier` СДЭК курьер  *   * Курьерская доставка СДЭК (не более одной записи на канал).  * - `Pickup` Самовывоз  *   * Самовывоз со склада (не более одной записи на канал).  * - `Manual` Без интеграции  *   * Способ без интеграции API (может быть несколько на канал).  * - `Pochta` Почта России  *   * Интеграция Почта России, только ОПС (не более одной записи на канал).  * - `PochtaCourier` Почта России курьер  *   * Курьерская доставка Почта России (не более одной записи на канал).  *   */
  @ActiveField(DeliveryMethodKind.CDEK)
  kind: DeliveryMethodKind = DeliveryMethodKind.CDEK


  /**
  * deliveryMethodId
  * Ссылка на запись каталога канала (если есть).  */
  @ActiveField(null)
  deliveryMethodId: null | number = null


/**
  * methodName
  * Снимок названия способа на момент оформления.
  */
  @ActiveField(null)
  methodName: null | string = null


  /**
  * from
  * Адрес отправления (CDEK / склад). Для Manual может не заполняться смыслом CDEK.<br>  */
  @ActiveField({
    factory: [CdekLocation, () => CdekLocation.create()]
  })
  from: CdekLocation = CdekLocation.create()


/**
  * methodInfo
  * Подробности конкретного метода доставки<br>  */
  @ActiveField({
  setter(model: OrderDeliveryDto, prop: string, value: OrderDeliveryMethodCdekDto | OrderDeliveryMethodCdekCourierDto | OrderDeliveryMethodPickupDto | OrderDeliveryMethodManualDto | OrderDeliveryMethodPochtaDto | OrderDeliveryMethodPochtaCourierDto, receiver?: OrderDeliveryDto ) {
      let concreteValue = value
      switch (value.kind) {
          case 'Cdek': {
            concreteValue = OrderDeliveryMethodCdekDto.create(value)
            break;
          }
          case 'CdekCourier': {
            concreteValue = OrderDeliveryMethodCdekCourierDto.create(value)
            break;
          }
          case 'Pickup': {
            concreteValue = OrderDeliveryMethodPickupDto.create(value)
            break;
          }
          case 'Manual': {
            concreteValue = OrderDeliveryMethodManualDto.create(value)
            break;
          }
          case 'Pochta': {
            concreteValue = OrderDeliveryMethodPochtaDto.create(value)
            break;
          }
          case 'PochtaCourier': {
            concreteValue = OrderDeliveryMethodPochtaCourierDto.create(value)
            break;
          }
      }

      return Reflect.set(
        model,
        prop,
        concreteValue,
        receiver
      )
    }
  })
  methodInfo: OrderDeliveryMethodCdekDto | OrderDeliveryMethodCdekCourierDto | OrderDeliveryMethodPickupDto | OrderDeliveryMethodManualDto | OrderDeliveryMethodPochtaDto | OrderDeliveryMethodPochtaCourierDto | null | undefined = undefined


  /**
  * calculatedPrice
  * Рассчитанная / зафиксированная стоимость доставки.  */
  @ActiveField(0)
  calculatedPrice: number = 0


/**
  * trackingUrl
  * Ссылка для отслеживания (опционально).
  */
  @ActiveField(null)
  trackingUrl: null | string = null


  /**
  * refundDelivery
  * Если true, то стоимость доставки была возвращена<br>  */
  @ActiveField(null)
  refundDelivery: null | boolean = null
}
